const __WEBPACK_NAMESPACE_OBJECT__ = lvflanders.digitaaldossier.ng.core;